<template>
  <div class="container page-content">
    <h1>{{ $route.meta.title }}</h1>

    <el-row>
      <el-col :span="24">
        <el-avatar
          :size="150"
          :src="user.photoUrl || defaultOption.avatar"
        ></el-avatar>

        <img :src="qrcode" alt="qrcode" style="vertical-align: top" />
      </el-col>
      <el-col :push="20" :span="4">
        <router-link
          :to="{ name: 'editLongTermUser', params: { id: $route.params.id } }"
        >
          <el-button type="primary" size="mini">編輯</el-button>
        </router-link>
        <el-button size="mini" @click="$router.back()">上一頁</el-button>
      </el-col>
    </el-row>

    <div class="border-container">
      <el-form ref="editUserForm" :inline="true" :model="user">
        <el-form-item label="權限開通">
          <el-switch
            v-model="user.authority"
            @change="updateAuthority"
          ></el-switch>
        </el-form-item>
      </el-form>

      <div class="order-info-section">
        <h2 class="title"><span>乘客資訊</span></h2>

        <div class="table-responsive">
          <table class="table table-hover">
            <tbody>
              <tr>
                <td>乘客姓名</td>
                <td>{{ user.name }}</td>
              </tr>
              <tr>
                <td>身份別</td>
                <td>{{ defaultOption.userClassLookup[user.class] }}</td>
              </tr>
              <tr>
                <td>區域類型</td>
                <td>{{ defaultOption.areaTypeLookup[user.areaType] }}</td>
              </tr>
              <tr>
                <td>住家電話</td>
                <td>{{ user.telephoneNumber || '無' }}</td>
              </tr>
              <tr>
                <td>手機1</td>
                <td>{{ user.firstMobilePhoneNumber || '無' }}</td>
              </tr>
              <tr>
                <td>手機2</td>
                <td>{{ user.secondMobilePhoneNumber || '無' }}</td>
              </tr>
              <tr>
                <td>行政區</td>
                <td>{{ user.area }}</td>
              </tr>
              <tr>
                <td>住家地址</td>
                <td>
                  {{ user.address }}
                  {{ user.addressGps ? user.addressGps.join(', ') : '' }}
                </td>
              </tr>
              <tr>
                <td>偏好服務</td>
                <td>
                  {{ userPreferService ? userPreferService.join(',') : '無' }}
                </td>
              </tr>

              <tr>
                <td>乘客資料備註</td>
                <td>{{ user.note || '無' }}</td>
              </tr>

              <tr>
                <td>自付比例</td>
                <td>{{ user.payForOwnselfProportion || 0 }}%</td>
              </tr>

              <tr>
                <td>就醫接送補助上限</td>
                <td>NT {{ user.communityLimitedFrequency || 0 }}</td>
              </tr>

              <tr>
                <td>就醫接送補助剩餘</td>
                <td>NT {{ user.subsidyLastAmount || 0 }}</td>
              </tr>

              <tr>
                <td>社區式接送</td>
                <td>{{ user.communityShuttleFrequency }}次</td>
              </tr>

              <tr>
                <td>社區式接送剩餘</td>
                <td>{{ user.lastCommunityShuttleFrequency }}次</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const log = console.log
import { defaultOption } from './defaultOption'
import QRCodeGenMixin from './_QRCodeGenMixin'
import longTermCareService from '@/API/longTermCareService'

export default {
  mixins: [QRCodeGenMixin],
  methods: {
    updateAuthority() {
      const { id } = this.$route.params
      const { authority } = this.user
      longTermCareService
        .updateUser(id, { authority })
        .then(() => this.$message.success(message))
    },
    fetchUserDetail() {
      const id = this.$route.params.id
      return longTermCareService
        .getUserById(id)
        .then((data) => {
          log('user detail: ', data)
          return data
        })
        .then((data) => {
          this.user = data.result
          return data
        })
    },
    fetchTeamAvailableService() {
      longTermCareService.getTeamAvailableServices().then(({ result }) => {
        this.teamAvailableServices = result
      })
    },
  },
  created() {
    this.fetchUserDetail().then(({ result }) => this.toBase64(result.qrcodeUrl))
    this.fetchTeamAvailableService()
  },
  data() {
    return {
      defaultOption,
      user: {},
      teamAvailableServices: [],
    }
  },
  computed: {
    userPreferService() {
      return this.user.service && this.user.service.length > 0
        ? this.teamAvailableServices.filter(
            (service) =>
              this.user.service.indexOf(service.teamServiceId) !== -1,
          )
        : null
    },
  },
}
</script>

<style scoped>
.border-container {
  border: 2px solid #ebeef5;
  padding: 5px 20px;
  margin-top: 20px;
}

.page-content {
  max-width: 960px;
  margin: auto;
}

.order-info-section {
  position: relative;
  margin-bottom: 30px;
}

.order-info-section .title {
  background: transparent;
  position: relative;
  text-align: center;
}
.order-info-section .title > span {
  display: inline;
  background: #fff;
  padding: 5px;
  margin: auto;
  z-index: 2;
}
.order-info-section .title::after {
  display: block;
  content: '';
  top: 50%;
  margin-top: -2px;
  width: 100%;
  position: absolute;
  border: 1px solid #e5e5e5;
  z-index: -1;
}

.table > tbody > tr > td {
  padding-top: 20px;
  padding-bottom: 5px;
  border-top: none;
  border-bottom: 1px solid #ddd;
}
.table > tbody > tr > td:first-child {
  text-align: right;
  width: 300px;
}

.el-avatar > img {
  object-fit: contain;
  width: inherit;
  height: inherit;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/UserDetail.vue